module.exports = __webpack_public_path__ + "static/media/lykke02.7c79efbd.jpg";